module.exports = __webpack_public_path__ + "img/img_level_13.ca784fa4.png";